import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'cmp-inactivity-modal',
	templateUrl: './inactivity-modal.component.html',
	standalone: false
  })

export class InactivityModalComponent {
    @Input() public displayedTime: string = '';
    @Output() public stillHereClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() public logOutClicked: EventEmitter<void> = new EventEmitter<void>();

	constructor() {
        // ctor
    }

    public stillHere(): void {
        this.stillHereClicked.emit();
    }

    public logOut(): void {
        this.logOutClicked.emit();
    }

}